var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOmniscient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96,48.2c-0.8-1-20.8-25.5-46-25.5c-25.3,0-45.2,24.5-46,25.5L2.5,50L4,51.8c0.8,1,20.8,25.5,46,25.5     c25.3,0,45.2-24.5,46-25.5l1.5-1.8L96,48.2z M10,50c3.4-3.7,11.9-12.2,22.8-17.4c-4.5,4.4-7.3,10.6-7.3,17.4     c0,6.8,2.8,12.9,7.2,17.3C21.9,62.2,13.4,53.7,10,50z M50,68.1C40,68.1,31.9,60,31.9,50c0-10,8.1-18.1,18.1-18.1     c10,0,18.1,8.1,18.1,18.1C68.2,60,60,68.1,50,68.1z M67.2,67.4c4.5-4.4,7.3-10.6,7.3-17.4c0-6.8-2.8-12.9-7.2-17.3     C78.1,37.8,86.6,46.3,90,50C86.6,53.7,78.1,62.2,67.2,67.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 50,
    cy: 50,
    r: 9.1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOmniscient);
export default __webpack_public_path__ + "static/media/omniscient.d342c1e0ddb76f25d83497f53e918831.svg";
export { ForwardRef as ReactComponent };